<script>

import isEmpty from 'lodash/isEmpty';
import FileApi from '@/api/common/file';
import MapAPI from '@/api/topologymap/common';
import WStorageConfigTable from '@/views/virtual/performance/group/config/components/StorageConfigTable';

export default {
  name: 'WTopologymapStorageConfigTable',
  extends: WStorageConfigTable,
  props: {
    active: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      params: {},
    };
  },
  computed: {
  },
  watch: {
    active: {
      handler() {
        this.loadStore();
      },
    },
  },
  methods: {
    loadStore() {
      if (this.active) {
        const tableParams = this.$refs.storageConfigTable.getParameter();
        this.params = {
          ...tableParams,
          mapId: this.$store.getters.getCurrentMapId,
          objtypeIds: ['VDS'],
        };
        this.columns = this.logicalColumns;
        MapAPI
          .getGroupConfigInfoForObjtype(this.params)
          .then((result) => {
            if (result.data.success === true) {
              this.tableDatas = result.data.data;
              this.tableTotal = result.data.total;
            }
          });
      }
    },
    onClickExportExcel() {
      MapAPI.getVmsConfigInfoTargetDeviceListExcelName(this.params).then((response) => {
        if (response.data.success && !isEmpty(response.data.data)) {
          FileApi.downloadExportedExcelFile(response.data.data);
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/topologymap/components/perfoper/config/components/virtual/TopologymapStorageConfigTable.vue